import "./LabInformationDeatailsAddComponent.scss";
import FormTitleWithNavigationBack
    from "../../../../shared/components/form-title-with-navigation-back/FormTitleWithNavigationBack";
import React, {useCallback, useEffect, useRef, useState} from "react";
import ButtonComponent from "../../../../shared/components/core/button/ButtonComponent";
import Grid from "@mui/material/Grid";
import {Field, FieldProps, Form, Formik, FormikHelpers, FormikProps, FormikValues} from "formik";
import FormikInputComponent from "../../../../shared/components/core/formik-input/FormikInputComponent";
import * as Yup from "yup";
import {CommonService} from "../../../../shared/services";
import _ from "lodash";
import FormikAutoCompleteDropdown
    from "../../../../shared/components/core/formik-auto-complete-dropdown/formikAutoCompleteDropdown";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import {APIConfig} from "../../../../constants";
import FromikPhoneNumberComponent
    from "../../../../shared/components/core/fromik-phone-number/FromikPhoneNumberComponent";
import commonService from "../../../../shared/services/common.service";
import {useParams, useSearchParams} from "react-router-dom";
import {LabRoleType} from "../../../../shared/models/lab.model";

interface LabInformationComponentProps {
    next: Function;
    cancel: Function;
    labDetails?: any;
    labID?: any;
}

const validationSchema = Yup.object({
    name: Yup.string().required("Lab Name is required"),
    labExternalId: Yup.string()
        .nullable()
        // .required('Lab ID is required')
        .max(20, "Lab ID should be Maximum 20 digits"),
    npiNumber: Yup.string()
        .nullable()
        .matches(/^[0-9]{10}$/, "Lab NPI Number should be 10 digits"),
    cliaId: Yup.string()
        .nullable()
        .required('CLIA ID is required')
        .matches(/^[A-Z0-9]{10}$/i, "CLIA ID should be 10 characters"),
    capId: Yup.string()
        .nullable()
        .matches(/^[0-9]{7}$/, "CAP ID should be 7 digits"),
    colaId: Yup.string().nullable()
        .matches(/^[0-9]{5}$/, "COLA ID should be 5 digits"),
    // labType: Yup.mixed()
    //     .nullable()
    //     .required('Lab Type is required'),
    emailId: Yup.string().nullable()
        .email("Invalid Email ID")
        .required("Email ID is required")
        .matches(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/, "Enter a valid Email ID"),
    mobileNumber: Yup.string().nullable().required("Mobile Number is required")
        .matches(/^[(]{0,1}[0-9]{3}[)]{0,1}[-\s]{0,1}[0-9]{3}[-\s]{0,1}[0-9]{4}$/, "Mobile Number should be 10 digits"),
    faxNumber: Yup.string().nullable()
        .matches(/^[(]{0,1}[0-9]{3}[)]{0,1}[-\s]{0,1}[0-9]{3}[-\s]{0,1}[0-9]{4}$/, "Fax Number should be 10 digits"),
    secondaryMobileNumber: Yup.string()
        .nullable()
        .matches(/^[(]{0,1}[0-9]{3}[)]{0,1}[-\s]{0,1}[0-9]{3}[-\s]{0,1}[0-9]{4}$/, "Mobile Number should be 10 digits"),
    addressLine1: Yup.string().nullable()
        .required("Address Line 1 is required")
        .max(200, 'Address Line 1 cannot exceed 200 characters'),
    addressLine2: Yup.string().nullable().max(200, 'Address Line 2 cannot exceed 200 characters'),
    zipcode: Yup.mixed().required("ZIP Code is required"),
    state: Yup.mixed().required("State is required"),
    city: Yup.mixed().required("City is required"),
    newZipCode: Yup.string().when('zipcode', {
        is: (zipcode: any) => (zipcode?.zipcode && zipcode?.zipcode?.toLowerCase() === "other"),
        then: Yup.string().required('ZIP Code is required').matches(/^[0-9]{5}$/, 'Enter a valid ZIP Code'),
    }),
});

interface CreateLabInformationFormSchema {
    name: string;
    labExternalId: string,
    npiNumber: string,
    cliaId: string,
    capId: string,
    colaId: string,
    // labType: null,
    mobileNumber: string,
    secondaryMobileNumber: string,
    faxNumber: string;
    emailId: string,
    addressLine1: string,
    addressLine2: string,
    zipcode: any,
    newZipCode: string,
    state: string,
    city: string,
}

const formInitialValues: CreateLabInformationFormSchema = {
    name: "",
    labExternalId: '',
    npiNumber: '',
    cliaId: '',
    capId: '',
    colaId: '',
    // labType: null,
    mobileNumber: "",
    secondaryMobileNumber: "",
    faxNumber: "",
    emailId: "",
    addressLine1: "",
    addressLine2: "",
    zipcode: {},
    newZipCode: "",
    state: "",
    city: "",
}
const LabInformationDetailsAddComponent = (props: LabInformationComponentProps) => {
    const {next, cancel, labDetails, labID} = props;
    const {labRole} = useParams<{ labRole?: LabRoleType }>();

    const [initialValues, setInitialValues] = useState<CreateLabInformationFormSchema>(formInitialValues);
    const formikRef = useRef<FormikProps<FormikValues>>(null);
    const [name, setLabName] = useState<string>('');
    const [isLabNameAlreadyTaken, setIsLabNameAlreadyTaken] = useState<any>(false);
    const APICallSubscription = useRef<any>(null);
    const [state, setState] = useState<string>("");
    const [isZipCodeNotFound, setIsZipCodeNotFound] = useState<boolean>(false);
    const [mode, setMode] = useState<string>("add");
    const [searchParams] = useSearchParams();
    const lastCompletedStep = parseInt(searchParams.get("lastCompletedStep") || '0');

    const handleZipCodeValueChange = useCallback((zipCodeObject: any, setFieldValue: any) => {
        if (zipCodeObject === "") {
            setFieldValue("state", "");
            setFieldValue("city", "");
            setFieldValue("timezone", "");
            setState("");
            setIsZipCodeNotFound(false);
        } else {
            if (zipCodeObject?.zipcode?.toLowerCase() === "other") {
                setIsZipCodeNotFound(true);
                setFieldValue("state", "");
                setFieldValue("city", "");
                setFieldValue("timezone", "");
            } else {
                setIsZipCodeNotFound(false);
                setFieldValue("state", zipCodeObject.state);
                setFieldValue("city", zipCodeObject.city);
                setFieldValue("timezone", zipCodeObject.timezone);
            }
        }
        setFieldValue("newZipCode", "");
    }, []);

    const labVerify = useCallback((name: any, setFieldError: any) => {
        const cancelTokenSource = CommonService.getCancelToken();
        const payload = {
            'name': name,
        };
        let apiCall;
        apiCall = CommonService._api.post;
        if (APICallSubscription && APICallSubscription.current) {
            APICallSubscription.current.cancel();
        }
        setIsLabNameAlreadyTaken(undefined);
        apiCall(APIConfig.VERIFY_LAB_NAME.URL, payload, {}, {cancelToken: cancelTokenSource.token}).then((response: IAPIResponseType<any>) => {
            if (response.data) {
                setIsLabNameAlreadyTaken(!response.data.isUnique);
                !response.data.isUnique && setFieldError("name", "Lab with the given name already exists! Please try another name.");
            }
        }).catch((error: any) => {

        });
    }, []);


    const onFormSubmit = useCallback((values: any, {setSubmitting, setErrors, validateForm}: FormikHelpers<any>) => {
        const payload = _.cloneDeep({...values, lastCompletedStep: lastCompletedStep});
        payload.name = name;
        // payload.labType = payload.labType.code;
        payload.labType='externalLab'
        setSubmitting(true);
        if (payload["newZipCode"]) {
            payload["zipcode"] = payload["newZipCode"];
            payload["state"] = payload?.state?.state;
            payload["city"] = payload?.city?.city;
            delete payload["newZipCode"];
        } else {
            payload["zipcode"] = payload?.zipcode?.zipcode;
        }
        payload["mobileNumber"] = payload["mobileNumber"]?.replace(/[^0-9]/g, '');
        payload["secondaryMobileNumber"] = payload["secondaryMobileNumber"]?.replace(/[^0-9]/g, '');
        payload["faxNumber"] = payload["faxNumber"]?.replace(/[^0-9]/g, '');
        payload['labRole'] = labRole;
        if (mode === "add") {
            CommonService._lab.addLabDetails(payload)
                .then((response: IAPIResponseType<any>) => {
                    setSubmitting(false);
                    CommonService._alert.showToast(response.message || "Lab added successfully", "success")
                    next(response.data.id, response?.data);
                })
                .catch((error: any) => {
                    CommonService.handleErrors(setErrors, error);
                    setSubmitting(false);
                    CommonService._alert.showToast(error.error || "Error while add Lab", "error")
                })
        } else {
            if (formikRef.current?.dirty) {
                commonService._lab.editLabDetails(labID, payload)
                    .then((response: IAPIResponseType<any>) => {
                        setSubmitting(false);
                        CommonService._alert.showToast(response.message || "Lab updated successfully", "success")
                        next(response.data.id, response?.data);
                    })
                    .catch((error: any) => {
                        CommonService.handleErrors(setErrors, error);
                        setSubmitting(false);
                        CommonService._alert.showToast(error.error || "Error while updating Lab", "error")
                    })
            } else {
                next(labID, labDetails);
            }
        }

    }, [lastCompletedStep, name, labRole, mode, next, labID, labDetails]);

    useEffect(() => {
        if (labDetails) {
            const labDetailsObject = _.cloneDeep(labDetails);
            const tempLabDetailsObject: any = {};
            if (!labDetailsObject.zipcodeDetails) {
                tempLabDetailsObject.newZipCode = labDetailsObject?.zipcode;
                tempLabDetailsObject.zipcode = {
                    zipcode: 'Other'
                }
                tempLabDetailsObject.state = labDetailsObject?.stateDetails;
                tempLabDetailsObject.city = labDetailsObject?.cityDetails;
                setIsZipCodeNotFound(true);
            } else {
                tempLabDetailsObject.zipcode = labDetailsObject.zipcodeDetails;
                tempLabDetailsObject.state = labDetailsObject.zipcodeDetails?.state;
                tempLabDetailsObject.city = labDetailsObject.zipcodeDetails?.city;
                setIsZipCodeNotFound(false);
            }
            tempLabDetailsObject.labType = {
                code: labDetailsObject.labType,
                title: commonService.codeToTitleConverter(labDetailsObject.labType)
            }
            tempLabDetailsObject.mobileNumber = commonService.getMaskedMobileNumber(labDetailsObject.mobileNumber);
            tempLabDetailsObject.secondaryMobileNumber = commonService.getMaskedMobileNumber(labDetailsObject.secondaryMobileNumber);
            tempLabDetailsObject.faxNumber = commonService.getMaskedMobileNumber(labDetailsObject?.faxNumber);
            tempLabDetailsObject.emailId = labDetailsObject.emailId;
            tempLabDetailsObject.addressLine1 = labDetailsObject.addressLine1;
            tempLabDetailsObject.addressLine2 = labDetailsObject.addressLine2;
            tempLabDetailsObject.name = labDetailsObject.name;
            tempLabDetailsObject.labExternalId = labDetailsObject.labExternalId;
            tempLabDetailsObject.cliaId = labDetailsObject.cliaId;
            tempLabDetailsObject.colaId = labDetailsObject.colaId;
            tempLabDetailsObject.npiNumber = labDetailsObject.npiNumber;
            tempLabDetailsObject.capId = labDetailsObject.capId;
            setMode("edit");
            setInitialValues(tempLabDetailsObject);
        }
    }, [labDetails]);

    return (
        <div className={'lab-information-screen t-form-screen screen'}>
            <FormTitleWithNavigationBack
                title={'Lab Information'}
                tooltipData={"In-house labs are those owned by the AdvanzInnovation organisation, whereas external labs are outsourced."}
            />
            <div className="t-form">
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    validateOnChange={true}
                    validateOnBlur={true}
                    enableReinitialize={true}
                    innerRef={formikRef}
                    onSubmit={onFormSubmit}
                >
                    {({isSubmitting, values, setFieldError, isValid, touched, setFieldValue, validateForm, errors}) => {
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        useEffect(() => {
                            validateForm();
                        }, [validateForm, values]);
                        return (
                            // eslint-disable-next-line no-script-url
                            <Form noValidate={true} action={'javascript:void'}>
                                <div className={'t-form-controls-wrapper'}>
                                    <Field name={'name'}>
                                        {
                                            (field: FieldProps) => (
                                                <FormikInputComponent
                                                    type={"text"}
                                                    label={"Lab Name"}
                                                    placeholder={"Enter Lab Name"}
                                                    id="lab_name"
                                                    required={true}
                                                    formikField={field}
                                                    onUpdate={(value: string) => {
                                                        if (value) {
                                                            setLabName(value);
                                                            labVerify(value, setFieldError);
                                                        }
                                                    }}
                                                />
                                            )
                                        }
                                    </Field>
                                    <div>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                                <Field name={'labExternalId'}>
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikInputComponent
                                                                label={'Lab ID'}
                                                                placeholder={'Enter Lab ID'}
                                                                type={"text"}
                                                                maxLength={20}
                                                                // required={true}
                                                                formikField={field}
                                                            />
                                                        )
                                                    }
                                                </Field>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                                <Field name={'npiNumber'}>
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikInputComponent
                                                                label={'Lab NPI Number'}
                                                                placeholder={'Enter Lab NPI Number'}
                                                                type={"text"}
                                                                maxLength={10}
                                                                required={false}
                                                                formikField={field}
                                                            />
                                                        )
                                                    }
                                                </Field>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                                <Field name={'cliaId'}>
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikInputComponent
                                                                label={'CLIA ID'}
                                                                placeholder={'Enter CLIA ID'}
                                                                type={"text"}
                                                                maxLength={10}
                                                                required={true}
                                                                formikField={field}
                                                            />
                                                        )
                                                    }
                                                </Field>

                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                                <Field name={'capId'}>
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikInputComponent
                                                                label={'CAP ID'}
                                                                placeholder={'Enter CAP ID'}
                                                                type={"text"}
                                                                maxLength={7}
                                                                required={false}
                                                                formikField={field}
                                                            />
                                                        )
                                                    }
                                                </Field>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                                <Field name={'colaId'}>
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikInputComponent
                                                                label={'COLA ID'}
                                                                placeholder={'Enter COLA ID'}
                                                                type={"text"}
                                                                maxLength={5}
                                                                required={false}
                                                                formikField={field}
                                                            />
                                                        )
                                                    }
                                                </Field>
                                            </Grid>
                                            {/*<Grid item xs={12} sm={12} md={6} xl={6}>*/}
                                            {/*    <Field name={'labType'}>*/}
                                            {/*        {*/}
                                            {/*            (field: FieldProps) => (*/}
                                            {/*                <FormikAutoCompleteDropdown*/}
                                            {/*                    label={'Lab Type'}*/}
                                            {/*                    placeholder={'Select Lab Type'}*/}
                                            {/*                    required={true}*/}
                                            {/*                    valueKey={'code'}*/}
                                            {/*                    data={CommonService._staticData.labType}*/}
                                            {/*                    formikField={field}*/}
                                            {/*                    getOptionLabel={(option => (option.title) || '')}*/}

                                            {/*                />*/}
                                            {/*            )*/}
                                            {/*        }*/}
                                            {/*    </Field>*/}
                                            {/*</Grid>*/}
                                        </Grid>
                                    </div>
                                    <div className="horizontal-line"/>
                                    <div className='form-sub-title'>Contact Details :</div>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <Field name={'emailId'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikInputComponent
                                                            label={'Email ID'}
                                                            placeholder={'Enter Email ID'}
                                                            type={"email"}
                                                            required={true}
                                                            formikField={field}
                                                        />
                                                    )
                                                }
                                            </Field>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Field name={'mobileNumber'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FromikPhoneNumberComponent
                                                            label={'Mobile Number'}
                                                            placeholder={'(000) 000-0000'}
                                                            maxLength={14}
                                                            required={true}
                                                            formikField={field}
                                                        />
                                                    )
                                                }
                                            </Field>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <Field name={'secondaryMobileNumber'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FromikPhoneNumberComponent
                                                            label={'Secondary Mobile Number'}
                                                            placeholder={'(000) 000-0000'}
                                                            maxLength={14}
                                                            formikField={field}
                                                        />
                                                    )
                                                }
                                            </Field>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Field name={'faxNumber'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FromikPhoneNumberComponent
                                                            label={'Fax Number'}
                                                            placeholder={'(000) 000-0000'}
                                                            maxLength={14}
                                                            formikField={field}
                                                        />
                                                    )
                                                }
                                            </Field>
                                        </Grid>
                                    </Grid>
                                    <div className="horizontal-line"/>
                                    <div className='form-sub-title'>Address Details :</div>
                                    <Field name={'addressLine1'}>
                                        {
                                            (field: FieldProps) => (
                                                <FormikInputComponent
                                                    label={'Address Line 1'}
                                                    placeholder={'Enter Address Line 1'}
                                                    type={"text"}
                                                    required={true}
                                                    formikField={field}
                                                />
                                            )
                                        }
                                    </Field>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <Field name={'addressLine2'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikInputComponent
                                                            label={'Address Line 2'}
                                                            placeholder={'Enter Address Line 2'}
                                                            type={"text"}
                                                            formikField={field}
                                                        />
                                                    )
                                                }
                                            </Field>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Field name={'zipcode'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikAutoCompleteDropdown
                                                            label={'ZIP Code'}
                                                            placeholder={'Start typing for ZIP Code'}
                                                            required={true}
                                                            formikField={field}
                                                            fullWidth={true}
                                                            openOnFocus={true}
                                                            url={APIConfig.ZIPCODE_LIST.URL}
                                                            method={APIConfig.ZIPCODE_LIST.METHOD}
                                                            searchMode={'serverSide'}
                                                            data={[]}
                                                            valueKey={"zipcode"}
                                                            dataListKey={"data.docs"}
                                                            onUpdate={(value: any) => {
                                                                handleZipCodeValueChange(value, setFieldValue)
                                                            }}
                                                            //Hiding other option from zipcode
                                                            // defaultData={[
                                                            //     {
                                                            //         zipcode: "Other"
                                                            //     }
                                                            // ]}
                                                            getOptionLabel={(option => (option.zipcode) || '')}
                                                        />
                                                    )
                                                }
                                            </Field>
                                        </Grid>
                                    </Grid>
                                    {isZipCodeNotFound && <>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6}>
                                                <Field name={'newZipCode'}>
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikInputComponent
                                                                placeholder={"Enter New ZIP Code"}
                                                                label={'New ZIP Code'}
                                                                required={true}
                                                                maxLength={5}
                                                                type={"text"}
                                                                formikField={field}
                                                            />
                                                        )
                                                    }
                                                </Field>

                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Field name={'state'}>
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikAutoCompleteDropdown
                                                                label={'State'}
                                                                required={true}
                                                                formikField={field}
                                                                url={APIConfig.STATE_LIST.URL}
                                                                method={APIConfig.STATE_LIST.METHOD}
                                                                searchMode={'serverSide'}
                                                                openOnFocus={true}
                                                                dataListKey={"data.docs"}
                                                                data={[]}
                                                                valueKey={'state'}
                                                                onUpdate={(value: any) => {
                                                                    setState(value?.state);
                                                                    field.form.setFieldValue("city", '');
                                                                }}
                                                                getOptionLabel={(option => (option.state) || '')}
                                                            />
                                                        )
                                                    }
                                                </Field>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6}>
                                                <Field name={'city'}>
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikAutoCompleteDropdown
                                                                label={'City'}
                                                                placeholder={'City'}
                                                                required={true}
                                                                valueKey={'city'}
                                                                id="city_auto_complete"
                                                                formikField={field}
                                                                searchMode={'serverSide'}
                                                                url={APIConfig.CITY_LIST.URL}
                                                                method={APIConfig.CITY_LIST.METHOD}
                                                                disabled={!state}
                                                                payload={{
                                                                    state: state,
                                                                    page: 1,
                                                                    limit: 100
                                                                }}
                                                                data={[]}
                                                                getOptionLabel={(option => (option.city) || '')}
                                                                dataListKey={"data.docs"}
                                                            />
                                                        )
                                                    }
                                                </Field>

                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                {/*<Field name={'timezone'}>*/}
                                                {/*    {*/}
                                                {/*        (field: FieldProps) => (*/}
                                                {/*            <FormikAutoCompleteDropdown*/}
                                                {/*                label={'Timezone'}*/}
                                                {/*                placeholder={'Timezone'}*/}
                                                {/*                required={true}*/}
                                                {/*                id="timezone_auto_complete"*/}
                                                {/*                formikField={field}*/}
                                                {/*                searchMode={'serverSide'}*/}
                                                {/*                url={APIConfig.CITY_LIST.URL}*/}
                                                {/*                method={APIConfig.CITY_LIST.METHOD}*/}
                                                {/*                disabled={!state}*/}
                                                {/*                payload={{*/}
                                                {/*                    state: state,*/}
                                                {/*                    page: 1,*/}
                                                {/*                    limit: 100*/}
                                                {/*                }}*/}
                                                {/*                data={[]}*/}
                                                {/*                getOptionLabel={(option => (option.city) || '')}*/}
                                                {/*                dataListKey={"data.docs"}*/}
                                                {/*            />*/}
                                                {/*        )*/}
                                                {/*    }*/}
                                                {/*</Field>*/}
                                            </Grid>
                                        </Grid>
                                    </>}
                                    {
                                        !isZipCodeNotFound && values?.zipcode?.zipcode && values?.zipcode?.zipcode !== "Other" &&
                                        <>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} sm={6}>
                                                    <Field name={'state'}>
                                                        {
                                                            (field: FieldProps) => (
                                                                <FormikInputComponent
                                                                    label={'State'}
                                                                    placeholder={'Enter state'}
                                                                    required={true}
                                                                    readOnly={true}
                                                                    formikField={field}
                                                                    type={"text"}
                                                                />
                                                            )
                                                        }
                                                    </Field>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <Field name={'city'}>
                                                        {
                                                            (field: FieldProps) => (
                                                                <FormikInputComponent
                                                                    label={'City'}
                                                                    placeholder={'Enter city*'}
                                                                    required={true}
                                                                    readOnly={true}
                                                                    formikField={field}
                                                                    type={"text"}
                                                                />
                                                            )
                                                        }
                                                    </Field>
                                                </Grid>
                                            </Grid>
                                        </>
                                    }
                                </div>
                                <div className="form-action-section">
                                    <ButtonComponent
                                        variant={'outlined'}
                                        fullWidth={true}
                                        type={'button'}
                                        color={"primary"}
                                        handleClick={cancel}
                                    >
                                        Cancel
                                    </ButtonComponent>
                                    <ButtonComponent
                                        color={"primary"}
                                        type={"submit"}
                                        variant={"contained"}
                                        disabled={!isValid || isLabNameAlreadyTaken}
                                        fullWidth={true}
                                        isLoading={isSubmitting}
                                    >
                                        Next
                                    </ButtonComponent>
                                </div>
                            </Form>
                        );
                    }
                    }
                </Formik>
            </div>
        </div>

    );
};

export default LabInformationDetailsAddComponent;
